module.exports = __webpack_public_path__ + "img/Liliana.1ee2d441.jpg";